import { Button, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import * as Yup from 'yup';

import { showError, showToast } from '../../constants/toasts';
import { Loader } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import {
  useLazyGetFuelTypeByIdQuery,
  useAddFuelTypeMutation,
  useUpdateFuelTypeMutation,
} from '../../service/fuelType';
import { CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';

const AddFuelType = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [addFuelType] = useAddFuelTypeMutation();
  const [updateFuelType] = useUpdateFuelTypeMutation();
  const [getDetail] = useLazyGetFuelTypeByIdQuery();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required('This field is required')
        .min(2, 'Minimum 2 characters are required'),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      const body = {
        name: values?.name || '',
      };

      if (id) {
        try {
          setLoading(true);
          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await updateFuelType({
            body: encryptedBody,
            id,
          }).unwrap();
          setLoading(false);

          if (response?.statusCode === 200) {
            showToast('Fuel type updated successfully');
            navigate('/vehicle-specifications/fuel-type');
          }
        } catch (error: any) {
          setLoading(true);

          showError(error?.data?.message || '');
          console.error(error);
        }
      } else {
        try {
          setLoading(true);

          const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await addFuelType({
            body: encryptedBody,
          }).unwrap();
          setLoading(false);

          if (response?.statusCode === 200) {
            showToast('Fuel type added successfully');
            navigate('/vehicle-specifications/fuel-type');
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || '');
          console.error(error);
        }
      }
    },
  });

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        formik.setFieldValue('name', response?.data?.name);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>{id ? 'Edit' : 'Add'} Fuel Type</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> -{' '}
            <span onClick={() => navigate('/vehicle-specifications/fuel-type')}>
              Vehicle Specifications
            </span>{' '}
            - <span onClick={() => navigate('/vehicle-specifications/fuel-type')}>Fuel Type</span> -{' '}
            {id ? 'Edit' : 'Add'}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Fuel Type</label>
              <TextField
                variant="outlined"
                placeholder="Fuel Type"
                fullWidth
                hiddenLabel
                name="name"
                id="name"
                className="text_field"
                inputProps={{ maxLength: 50 }}
                value={formik.values.name}
                onChange={(val) => {
                  if (val.target.value === ' ' || val.target.value === '.') {
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.name && formik.errors.name}
              />
            </div>
          </div>

          <div className="form_end_btn">
            <Button className="btn btn_secondary" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddFuelType;
